import { render, staticRenderFns } from "./filterBlock.vue?vue&type=template&id=66008929&scoped=true&"
import script from "./filterBlock.vue?vue&type=script&lang=js&"
export * from "./filterBlock.vue?vue&type=script&lang=js&"
import style0 from "./filterBlock.vue?vue&type=style&index=0&id=66008929&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66008929",
  null
  
)

export default component.exports